<template>
  <div>
    <div class="d-flex gap-2 mb-6">
      <tm-skeleton
        height="36px"
        width="12%"
      />
      <tm-skeleton
        height="36px"
        width="24%"
      />
      <tm-skeleton
        height="36px"
        width="10%"
      />
    </div>
    <tm-skeleton-details-table-redesign />
  </div>
</template>

<script lang="ts" setup>
import TmSkeleton from '@/components/shared/skeletons/TmSkeleton.vue'
import TmSkeletonDetailsTableRedesign from '@/components/shared/skeletons/TmSkeletonDetailsTableRedesign.vue'
</script>
